import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/gemini-social-media";

export const Route = createFileRoute(path)({
	component: GeminiSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using Gemini",
			description:
				"Use Gemini to draft, schedule, and publish social media posts. Connect AgentReacher's MCP server and turn Gemini into a publishing operator.",
		}),
});

function GeminiSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="gemini"
				title="Boost your Social Media using Gemini"
				description="AgentReacher gives Gemini real publishing tools through MCP. Draft, schedule, and ship posts across every network without leaving the chat."
				primaryCta={{ label: "Connect Gemini", to: "/signup" }}
				secondaryCta={{ label: "Setup docs", to: "/docs/mcp" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
